import React from "react";
import { Form, Button } from "react-bootstrap";
import { Select, Input } from "antd";
import { PRESCRIPTION_TEST } from "modules/utilities/utility";

function PrescriptionTest({
  prescriptionStoreTest,
  setPrescriptionStoreTest,
  medicineTest,
  setMedicineTest,
}) {
  const handleMedicineChange = (index, value) => {
    const updatedMedicines = prescriptionStoreTest.map((item, idx) =>
      idx === index
        ? { ...item, test: value === "Other" ? "" : value, isCustom: value === "Other" }
        : item
    );
    setPrescriptionStoreTest(updatedMedicines);
  };

  const handleCustomInputChange = (index, event) => {
    const updatedMedicines = prescriptionStoreTest.map((item, idx) =>
      idx === index ? { ...item, test: event.target.value } : item
    );
    setPrescriptionStoreTest(updatedMedicines);
  };

  const handleAddMedicine = () => {
    setPrescriptionStoreTest([...prescriptionStoreTest, { ...medicineTest }]);
    setMedicineTest({
      test: "",
      isCustom: false,
    });
  };

  const handleRemoveMedicine = (index) => {
    const updatedMedicines = prescriptionStoreTest.filter(
      (_, idx) => idx !== index
    );
    setPrescriptionStoreTest(updatedMedicines);
  };

  const renderMedicineInputs = () => {
    return prescriptionStoreTest.map((item, index) => (
      <div key={index} className="d-flex justify-content-between gap-2">
        <Form.Group key={`test-${index}`} className="mb-3 w-100">
          {!item.isCustom ? (
            <Select
              showSearch
              value={item.test}
              onChange={(value) => handleMedicineChange(index, value)}
              placeholder="Select a test"
              className="w-100"
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
              }
            >
              {PRESCRIPTION_TEST.map((test) => (
                <Select.Option key={test} value={test}>
                  {test}
                </Select.Option>
              ))}
              <Select.Option key="other" value="Other">
                Enter custom test....
              </Select.Option>
            </Select>
          ) : (
            <Input
              value={item.test}
              onChange={(event) => handleCustomInputChange(index, event)}
              placeholder="Enter custom test"
              className="w-100"
            />
          )}
        </Form.Group>

        <Button
          variant="danger"
          className="h-75"
          onClick={() => handleRemoveMedicine(index)}
        >
          -
        </Button>
      </div>
    ));
  };

  return (
    <div>
      <Form>
        {renderMedicineInputs()}
        <div className="d-flex justify-content-between gap-2">
          <Form.Group key="new-test" className="mb-3 w-100">
            {!medicineTest.isCustom ? (
              <Select
                showSearch
                value={medicineTest.test}
                onChange={(value) =>
                  setMedicineTest({
                    ...medicineTest,
                    test: value === "Other" ? "" : value,
                    isCustom: value === "Other",
                  })
                }
                placeholder="Select a test"
                className="w-100"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
                }
              >
                {PRESCRIPTION_TEST.map((test) => (
                  <Select.Option key={test} value={test}>
                    {test}
                  </Select.Option>
                ))}
                <Select.Option key="other" value="Other">
                  Enter custom test....
                </Select.Option>
              </Select>
            ) : (
              <Input
                value={medicineTest.test}
                onChange={(event) =>
                  setMedicineTest({ ...medicineTest, test: event.target.value })
                }
                placeholder="Enter custom test"
                className="w-100"
              />
            )}
          </Form.Group>
          <Button variant="info" className="h-75" onClick={handleAddMedicine}>
            +
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default PrescriptionTest;
